/**
 * 관리자 대시보드 컴포넌트
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../shared/constants/routes';
import { Card } from '../../../../shared/components/UI/Card';
import styles from './Dashboard.module.css';

export const Dashboard: React.FC = () => {
  return (
    <div className={styles.dashboard}>
      <h1 className={styles.title}>관리자 대시보드</h1>

      <div className={styles.cardGrid}>
        {/* 메인 슬라이더는 정적 이미지로 변경되어 관리 기능 비활성화 */}
        {/* <Link to={ROUTES.ADMIN.SLIDER} className={styles.cardLink}>
          <Card>
            <h2>메인 슬라이더</h2>
            <p>홈페이지 메인 슬라이더 이미지를 관리합니다.</p>
          </Card>
        </Link> */}

        {/* 게시판별 카드 */}
        <Link to={ROUTES.ADMIN.BOARD_SUNDAY_SCHOOL} className={styles.cardLink}>
          <Card>
            <h2>교회학교 게시판</h2>
            <p>교회학교 게시글을 관리합니다.</p>
          </Card>
        </Link>

        <Link to={ROUTES.ADMIN.BOARD_NEWS} className={styles.cardLink}>
          <Card>
            <h2>교회소식 게시판</h2>
            <p>교회소식 게시글을 관리합니다.</p>
          </Card>
        </Link>

        <Link to={ROUTES.ADMIN.BOARD_GALLERY} className={styles.cardLink}>
          <Card>
            <h2>갤러리 게시판</h2>
            <p>갤러리 게시글을 관리합니다.</p>
          </Card>
        </Link>

        <Link to={ROUTES.ADMIN.BOARD_BULLETIN} className={styles.cardLink}>
          <Card>
            <h2>주보 게시판</h2>
            <p>주보 게시글을 관리합니다.</p>
          </Card>
        </Link>

        {/* <Link to={`${ROUTES.ADMIN.DASHBOARD}/new-family`} className={styles.cardLink}>
          <Card>
            <h2>새가족 관리</h2>
            <p>새가족 등록 정보를 확인하고 관리합니다.</p>
          </Card>
        </Link> */}
      </div>
    </div>
  );
};
